<template>
  <v-chip
    :class="chipClass"
    :color="chipStyle.colour"
    @click:close="$emit(filter && filterIcon && inputValue ? 'handleFilter' : 'close')"
    :label="label"
    :outlined="outlined"
    :small="small"
    @click="$emit('click')"
    :close="filter && filterIcon ? true : close"
    :disabled="disabled"
    :large="large"
    :ripple="ripple"
    :text-color="chipStyle.textColour"
    :close-icon="filter && filterIcon && !inputValue ? filterIcon : closeIcon"
  >
    <slot name="default">
      <v-avatar 
        v-if="avatar || avatarIcon"
        left
      >
        <v-icon 
          circle
          v-if="avatarIcon"
        >
          {{ this.avatarIcon }}
        </v-icon>
        <span v-if="avatar">{{ this.avatar }}</span>
      </v-avatar>
      <span>{{ this.inputValue ? this.inputValue : this.text }}</span>
    </slot>
  </v-chip>
</template>
<script>
export default {
  name: "Chip",
  data() {
    return {};
  },
  props: {
    chipClass: {
      type: String,
      default: ""
    },
    colour: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Chip Text"
    },
    close: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    ripple: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    filterIcon: {
      type: String,
      default: "arrow_drop_down"
    },
    textColor: {
      type: String,
      default: "#041E42"
    },
    avatar: {
      type: String,
      default: ""
    },
    avatarIcon: {
      type: String,
      default: null
    },
    closeIcon: {
      type: String,
      default: "cancel"
    },
    inputValue: {
      type: String,
      default: null
    }
  },
  computed: {
    chipStyle() {
      if (this.outlined) {
        return {
          colour: this.colour ? this.colour : "",
          textColour: this.textColor ? this.textColor : ""
        };
      } else {
        return {
          colour: this.colour ? this.colour : "",
          textColour: this.textColor ? this.textColor : "#ffffff"
        };
      }
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
